import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
import CheckboxSelectAll from "stimulus-checkbox-select-all/dist/stimulus-checkbox-select-all.umd";

const application = Application.start();

// Auto-register all controllers in this directory
const context = require.context(".", true, /_controller\.js$/);
application.load(definitionsFromContext(context));

// Register external package controllers
application.register("checkbox-select-all", CheckboxSelectAll);

// Test/dev affordance: expose the Stimulus application so system specs
// (and ad-hoc console debugging) can introspect controllers/outlets.
// Webpacker sets NODE_ENV=production for prod builds, so this is a no-op there.
if (process.env.NODE_ENV !== "production") {
  window.Stimulus = application;
}

export { application };
